import React from "react";
import { createListTableColumns, renderOptionalName, ShimmeredDetailsList } from "sprint-common-web";

import { renderActionStatus } from "../../../../../common/utils/renderActionStatus";
import { renderContent } from "../../../../common/components/listings/renderContent";
import { OnPremOrderListingItem } from "../../OnPremOrderListingItem";
import {
    ProcessUpdateOrderStatusRequestItem,
    UpdateOnPremOrderStatusRequestItem
} from "./UpdateOnPremOrderStatusRequestItem";

interface UpdateMultipleOnPremOrdersSummaryListProps {
    items: ProcessUpdateOrderStatusRequestItem[];
}

export const UpdateMultipleOnPremOrdersSummaryList: React.VFC<UpdateMultipleOnPremOrdersSummaryListProps> = ({
    items
}: UpdateMultipleOnPremOrdersSummaryListProps) => {
    const columns = createListTableColumns<ProcessUpdateOrderStatusRequestItem>([
        {
            type: "basic",
            key: "pONumber",
            name: "PO Number",
            minWidth: 75,
            maxWidth: 90
        },
        {
            type: "basic",
            key: "content",
            name: "Content",
            minWidth: 75,
            maxWidth: 160,
            onRender: renderContent
        },
        {
            type: "basic",
            key: "airline",
            name: "Airline",
            minWidth: 45,
            maxWidth: 100,
            onRender: renderOptionalName
        },
        {
            type: "basic",
            key: "system",
            name: "System",
            minWidth: 48,
            maxWidth: 80,
            onRender: renderOptionalName
        },
        {
            type: "basic",
            key: "processStatus",
            name: "Process status",
            minWidth: 100,
            onRender: renderActionStatus
        }
    ]);

    return <ShimmeredDetailsList columns={columns} items={items} layoutMode="fixedColumns" />;
};

export const mapToSendOrderRequestItem = (orderRequest: OnPremOrderListingItem): UpdateOnPremOrderStatusRequestItem => {
    return {
        id: orderRequest.id,
        content: orderRequest.content,
        pONumber: orderRequest.pONumber,
        airline: orderRequest.airline,
        status: orderRequest.status,
        system: orderRequest.system
    };
};
